import { render, staticRenderFns } from "./PdpAddToWishlist.vue?vue&type=template&id=f40df4c8&scoped=true&"
import script from "./PdpAddToWishlist.vue?vue&type=script&lang=js&"
export * from "./PdpAddToWishlist.vue?vue&type=script&lang=js&"
import style0 from "./PdpAddToWishlist.vue?vue&type=style&index=0&id=f40df4c8&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40df4c8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIconCircle: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/svg/IconCircle.vue').default,AppButton: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppButton.vue').default})
